class CartLink extends HTMLElement {
  constructor() {
    super();

    this.itemsCount = this.querySelector('items-count');
  }

  connectedCallback() {
    this.unsubscribe = window.theme.cart.store.subscribe((state) => {
      this.itemsCount.innerHTML = state.products.item_count;

      // エラー文言・チェックアウトボタンの要素
      const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
      const checkoutDisabled = document.getElementById('cart-checkout-disabled');
      const checkoutButton = document.getElementById('checkout');

      switch (true) {
        // 3個未満の場合の処理
        case state.products.item_count < 4:
          errorWrapper?.style.setProperty('display', 'none');
          if (checkoutDisabled && checkoutButton) {
            checkoutDisabled.style.setProperty('display', 'none');
            checkoutButton.style.setProperty('display', 'block');
            checkoutButton.disabled = false;
          }
          break;
        // 4個以上の場合の処理
        case state.products.item_count >= 4:
          errorWrapper?.style.setProperty('display', 'block');
          if (checkoutDisabled && checkoutButton) {
            checkoutDisabled.style.setProperty('display', 'block');
            checkoutButton.style.setProperty('display', 'none');
            checkoutButton.disabled = true;
          }
          break;
      }
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }
}
customElements.define('cart-link', CartLink);
